import React, { useState, useEffect } from "react";
import "../../assets/style/eegisterProvider.css";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import OTPInput, { ResendOTP } from "otp-input-react";
import { Link, json, useNavigate } from "react-router-dom";
import Web3 from "web3";
import Api from "../../utils/Api";
import { toast } from "react-toastify";
import contractABI from "../../utils/contractABI";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const Login = () => {
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
  let Navigater = useNavigate();
  const [OTP, setOTP] = useState("");
  const [web3, setWeb3] = useState(null);
  const [contracts, setContract] = useState(null);
  const [isconnected, setisconnected] = useState(false);
  const [signer, setSigner] = useState(null);
  const [name, setName] = useState("");
  const [txhash, setTxHash] = useState({});

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [Validations, setValidations] = useState({
    email: "",
    password: "",
  });

  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };

  useEffect(() => {
    const initContract = async () => {
      try {
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage
      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);

  // const navigate = useNavigate();
  const Navigate = useNavigate();

  const renderSeparator = (index) => {
    if (index === 3) {
      return <span>-</span>;
    }
    return null;
  };

  const inputStyle = {
    width: "2rem", // Adjust the width as needed
    height: "2rem", // Adjust the height as needed
    fontSize: "1.5rem", // Adjust the font size as needed
    border: "1px solid #ccc", // Add a border for the input fields
    borderRadius: "4px", // Add rounded corners
    margin: "0.25rem", // Add some margin between input fields
    textAlign: "center", // Center the text within the input field
  };

  const registerProvider = async () => {
    // console.log("Name is Rafay",contracts)
    try {
      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];
      console.log(account);
      const result = await contracts.methods
        .registerProvider(name)
        .send({ from: account });
      setTxHash(result.transactionHash);
      if (result?.transactionHash) {
        console.log(result);
        // setShowModal(true);
        setTimeout(() => {
          // setShowModal(false);
          // Navigate("/main");

          alert(`${result} jasgfjkgasjgfjasgfjg`);
        }, 5000);
      } else {
        alert("Not transaction DOne Successfully");
        // setShowModal(false);
      }
    } catch (error) {
      console.error(error);
    }

    // setLoading(false);
  };

  const onSumit = async () => {
    try {
      
      console.log("==========", email);
      console.log("==========", password);
      
      let error = {};
      if (!email) {
        error.email = "Email is required";
      }

      if (!password) {
        error.password = "Password is required";
      }
      
      if (Object.keys(error).length > 0) {
        setValidations(error);
        return;
      }

      // Try to login with all possible roles automatically
      // Order matters - try most common roles first
      const roles = ["provider", "consumer", "fundSubscriber", "admin"];
      let loginData = null;
      let successfulRole = null;

      for (const role of roles) {
        try {
          console.log(`🚀 ~ Trying login with role: ${role}`);
          
          loginData = await Api.Api.post("/user/login", {
            email: email,
            password: password,
            role: role,
          });
          
          if (loginData.data.success) {
            successfulRole = role;
            break;
          } else if (loginData.data.user && loginData.data.user.isVerified === false) {
            // Handle unverified user case
            console.log(`🚀 ~ User not verified for role: ${role}`);
            localStorage.setItem("otpemail", email);
            localStorage.setItem("otprole", role);
            console.log("🚀 ~ User not verified, redirecting to OTP verification with role:", role);
            Navigater("/auth/varifyOTP");
            return; // Exit the function
          }
        } catch (error) {
          console.log(`🚀 ~ Login failed with role ${role}:`, error.response?.data?.message || error.message);
          console.log(`🚀 ~ Error response:`, error.response?.data);
          
          // Check if this is an unverified user error (409 Conflict with specific message)
          if (error.response?.status === 409 && error.response?.data?.message === "You haven't been verified") {
            console.log(`🚀 ~ User not verified for role: ${role}`);
            localStorage.setItem("otpemail", email);
            localStorage.setItem("otprole", role);
            console.log("🚀 ~ User not verified, redirecting to OTP verification with role:", role);
            Navigater("/auth/varifyOTP");
            return; // Exit the function
          }
          
          // Check if this is an unapproved user error (409 Conflict with admin approval message)
          if (error.response?.status === 409 && error.response?.data?.message === "You haven't been approved by admin yet") {
            console.log(`🚀 ~ User not approved by admin for role: ${role}`);
            // Show a specific message for admin approval
            toast.error("Your account is verified but pending admin approval. Please contact the administrator.");
            return; // Exit the function
          }
          
          continue; // Try next role
        }
      }

      if (loginData && loginData.data.success) {
        console.log(
          "🚀 ~ file: login.js:543 ~ onSumit ~ loginData:",
          loginData
        );
        
        localStorage.setItem(
          "name",
          loginData.data.user.institutionName
            ? loginData.data.user.institutionName
            : `${loginData.data.user.firstName} ${loginData.data.user.lastName}`
        );
        localStorage.setItem("userData", loginData.data.token);
        localStorage.setItem("status", loginData.data.user.status);
        
        // Map backend role back to frontend role for localStorage
        let frontendRole = loginData.data.role;
        if (loginData.data.role === "provider" || loginData.data.role === "Provider") {
          frontendRole = "Fund Provider";
        } else if (loginData.data.role === "fundSubscriber" || loginData.data.role === "Fund Subscriber") {
          frontendRole = "Fund Subscriber";
        } else if (loginData.data.role === "admin" || loginData.data.role === "Admin") {
          frontendRole = "Admin";
        }
        localStorage.setItem("role", frontendRole);
        localStorage.setItem("image", loginData?.data?.user?.profileImage);
        localStorage.setItem("id", loginData.data.user._id);
        
        
        if (loginData.data.role == "provider" || loginData.data.role == "Provider") {
          Navigate("/admin-panel/ProviderProfile");
        }
        else if(loginData.data.role == "fundSubscriber" || loginData.data.role == "Fund Subscriber"){
          Navigate("/admin-panel/BuyFundAssets");
        }
        else if (loginData.data.role == "admin" || loginData.data.role == "Admin") {
          Navigate("/admin-panel/Dashboard");
        }
        else {
          // For any other role, redirect to login instead of dashboard
          Navigate("/auth/Login");
        }

        toast.success("Login Successfully");
      } else {
        console.log("Not yet===================>>>>");
        toast.error("Login Failed - Invalid credentials or server response");
      }
    } catch (error) {
      console.log("Login error:", error);
      
      if (error.response) {
        const errorMessage = error.response.data?.message || 'Login failed';
        toast.error(errorMessage);
        
        if (error?.response?.data?.user?.isVerified == false) {
          localStorage.setItem("otpemail", email);
          // Try to get role from error response, fallback to successfulRole if available
          const userRole = error?.response?.data?.user?.role || successfulRole || "provider";
          localStorage.setItem("otprole", userRole);
          console.log("🚀 ~ User not verified, redirecting to OTP verification with role:", userRole);
          Navigater("/auth/varifyOTP");
        }
      } else if (error.code === 'ECONNREFUSED') {
        toast.error("Backend server is not running. Please start the backend server on port 5000");
      } else if (error.message) {
        toast.error(`Network error: ${error.message}`);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={{ display:"flex",justifyContent:"center",marginTop:"10%", width: "100%", backgroundColor: "#F3F4F8" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width:"50%"
        }}
      >
        <span className="Loginheading">Login</span>
        <div className="LoginScreen">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <span style={{ width: "90%", fontFamily: "Manrope, sans-serif" }}>
                Email
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <TextField
                helperText={Validations.email}
                error={!!Validations.email}
                onChange={(e) => {
                  setemail(e.target.value);
                }}
                style={{ width: "90%" }}
                id="outlined-email"
                label="Enter your Email"
                variant="outlined"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <span style={{ width: "90%", fontFamily: "Manrope, sans-serif" }}>
                Password
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
              }}
            >
              <TextField
                onChange={(e) => {
                  setpassword(e.target.value);
                }}
                style={{ width: "90%" }}
                type={showPassword ? "text" : "password"}
                helperText={Validations.password}
                error={!!Validations.password}
                id="outlined-password"
                label="Enter Your Password"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "90%",
              alignSelf: "center",
              justifyContent: "flex-start",
            }}
          >
            <div>
              <Link to="/auth/varifyEmail"
                style={{color:"blue"}}
              >
                <span
                  style={{ fontFamily: "Manrope, sans-serif", cursor: "pointer" }}
                >
                  Forgot Password?
                </span>
              </Link>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "90%",
              alignSelf: "center",
              justifyContent: "flex-end",
              paddingBottom: 20,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Button
                onClick={onSumit}
                variant="outlined"
              >
                Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
